$('.datepicker').datepicker();